export default __webpack_public_path__ + "static/media/1016.6beb8f0e.png";